// extracted by mini-css-extract-plugin
module.exports = {"container":"HeroSection_container__Db2Qv","videoWrapper":"HeroSection_videoWrapper__94w_9","titleWrapper":"HeroSection_titleWrapper__B1dcf"};